module.exports = __webpack_public_path__ + "static/media/secretary.977e2557.svg";